import { ThumbsUp, ThumbsDown } from "./icons";
import { cn } from "../lib/utils";

interface ChatFeedbackButtonsProps {
  onThumbsUp: () => void;
  onThumbsDown: () => void;
  className?: string;
}

export function ChatFeedbackButtons({ onThumbsUp, onThumbsDown, className }: ChatFeedbackButtonsProps) {
  return (
    <div className={cn("chat-feedback-buttons flex items-center gap-2 mt-2", className)}>
      <button
        onClick={onThumbsUp}
        className="chat-feedback-thumb p-1 rounded hover:bg-zinc-700 transition-colors opacity-60 hover:opacity-100"
        title="This response was helpful"
      >
        <ThumbsUp size={14} className="text-zinc-400 hover:text-green-400" />
      </button>
      <button
        onClick={onThumbsDown}
        className="chat-feedback-thumb p-1 rounded hover:bg-zinc-700 transition-colors opacity-60 hover:opacity-100"
        title="This response was not helpful"
      >
        <ThumbsDown size={14} className="text-zinc-400 hover:text-red-400" />
      </button>
    </div>
  );
}
